import { Button, NumberField, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

type EmployeesTurnoverProps = {
  defaultEmployees: number;
  defaultTurnover: number;
  onNextButtonClick: () => void;
  onBackButtonClick: () => void;
};

function EmployeesTurnover({
  defaultEmployees,
  defaultTurnover,
  onNextButtonClick,
  onBackButtonClick,
}: EmployeesTurnoverProps) {
  const { t } = useTranslation(["common", "externalCampaign"]);

  return (
    <div>
      <Typography className="mb-lg">
        {t("externalCampaign:employeesTurnover.description")}
      </Typography>
      <div className="gap-y-xs flex flex-col">
        <NumberField
          name="turnover"
          label={t("externalCampaign:employeesTurnover.turnover.label")}
          defaultValue={defaultTurnover}
          fullWidth
          unit={t("common:unit.eurosPerYear")}
        />
        <NumberField
          name="employees"
          label={t("externalCampaign:employeesTurnover.employees.label")}
          defaultValue={defaultEmployees}
          fullWidth
        />
      </div>

      <div className="mt-lg gap-x-sm flex justify-center">
        <Button shape="link" onClick={onBackButtonClick}>
          {t("common:back")}
        </Button>
        <Button onClick={onNextButtonClick}>{t("common:next")}</Button>
      </div>
    </div>
  );
}

export default EmployeesTurnover;
